module.exports = __webpack_public_path__ + "img/web.6f6b2a97.png";